<template>
  <slider />

  <the-nav />

  <div class="main-wrap">
    <game-list-no-slider
      v-if="this.byCategory"
      :games="this.gamesByCategory(this.byCategory)"
      :category="this.categoryBySlug(this.byCategory)"
      :manufacturer="this.manufacturerBySlug(this.byCategory)"
    />
    <game-list-no-slider
      v-else-if="this.byManufacturer"
      :games="this.gamesByCategory(this.byManufacturer)"
      :category="this.categoryBySlug(this.byManufacturer)"
      :manufacturer="this.manufacturerBySlug(this.byManufacturer)"
    />
    <game-list-no-slider
      v-else-if="this.byTopic"
      :games="this.gamesByTopic(this.byTopic)"
      :category="this.topicBySlug(this.byTopic)"
      :manufacturer="this.manufacturerBySlug(this.byTopic)"
    />

    <jackpot-block />

    <slot-topics />

    <bonuses-line />

    <play-line />

    <site-info />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Slider from '@/components/sliders/Slider'
import SlotTopics from '@/components/SlotTopics'
import PlayLine from '@/components/PlayLine'
import GameListNoSlider from '@/components/GameListNoSlider'
import TheNav from '@/components/TheNav'
import vendors from '@/components/Manufacturers'
import JackpotBlock from '@/components/JackpotBlock'
import HomeMiddleBlock from '@/components/HomeMiddleBlock'
import SiteInfo from '@/components/SiteInfo'
import { useI18n } from 'vue-i18n'
import WinnersBlock from '@/components/Winners'
import BonusesLine from '@/components/BonusesLine.vue'

export default {
  name: 'category',
  components: {
    SiteInfo,
    BonusesLine,
    JackpotBlock,
    WinnersBlock,
    HomeMiddleBlock,
    GameListNoSlider,
    vendors,
    TheNav,
    PlayLine,
    SlotTopics,
    Slider,
  },
  data() {
    return {
      search: '',
    }
  },
  setup() {
    const { t, locale } = useI18n()
    return { t, locale }
  },
  computed: {
    ...mapGetters([
      'isLoading',
      'games',
      'manufacturers',
      'gamesSearch',
      'gamesByCategory',
      'gamesByTopic',
      'gamesByManufacturer',
      'categories',
      'categoryBySlug',
      'manufacturerBySlug',
      'topicBySlug',
    ]),
    byCategory() {
      if (this.$route.name !== 'category') {
        return false
      }
      return this.$route.params.category
    },
    byManufacturer() {
      if (this.$route.name !== 'category-manufacturer') {
        return false
      }
      return this.$route.params.manufacturer
    },
    byTopic() {
      if (this.$route.name !== 'category-topic') {
        return false
      }
      return this.$route.params.topic
    },
  },
}
</script>
